<!-- Events -->
<!-- itemCreated -->

<template>
  <v-container fluid>
    <v-row>
      <v-data-table
        fixed-header
        :headers="headers"
        :items="items"
        :items-per-page="200"
        :loading="overlayDisplay"
        item-key="tkt_id"
        :height="tableHeight"
        style="width: 98%"
      >
        <template v-slot:item.is_public="{ item }">
          <v-simple-checkbox
            v-model="item.is_public"
            disabled
          ></v-simple-checkbox>
        </template>     </v-data-table>
    </v-row>
  </v-container>
</template>

<script>
  // Utilities
  import { mapActions, mapGetters } from 'vuex'
  import {
    PLAN_GET_PLANS,
  } from '../../store/actions.types'
  import basicMixin from '../../mixins/basic'
  export default {
    name: 'ListPlans',

    mixins: [basicMixin],
    inheritAttrs: false,

    props: {
      item: {
        type: Object,
        default: () => ({
          name: undefined,
          invoice: undefined,
          due_date: undefined,
          total: undefined,
          paid: undefined,
          is_paid: undefined,
          details: undefined,
        }),
      },
      tableH: {
        type: Number,
        default: 500,
      },
    },
    data: function () {
      return {
        currentObject: {},
        snapshotObject: {},
        formMode: '',
        formErrors: [],
        overlayAbsolute: true,
        overlayDisplay: false,
        headers: [
          {
            text: 'Display',
            align: 'start',
            sortable: false,
            value: 'display_text',
          },
          { text: 'Status', value: 'status' },
          { text: 'Price', value: 'price' },
          {
            text: 'Public',
            value: 'is_public',
            groupable: true,
          },
          {
            text: 'Store',
            value: 'fk_store_id',
            groupable: true,
          },
        ],
        windowSize: {
          x: 0,
          y: 0,
        },
      }
    },

    computed: {
      ...mapGetters('planModule', {
        items: 'list',
        selectedPlan: 'activePlan',
      }),
      tableHeight () {
        return this.windowSize.y - 300 + 'px'
      },
    },
    async created () {
      // this.init()
    },
    async mounted () {
      this.init()
      this.onResize()
    },
    methods: {
      ...mapActions('planModule', {
        queryPlans: PLAN_GET_PLANS,
      }),
      async init () {
        console.log(`Initializing ${name} setting values!`, this.item)
        this.formMode = 'read'
        this.overlayDisplay = true
        await this.queryPlans()
        this.overlayDisplay = false
        // console.log(val)
        // this.currentObject = { ...this.item }
        // this.snapshotObject = { ...this.item }
      },
      resetForm () {
        this.overlayDisplay = false
        this.currentObject = { ...this.snapshotObject }
        this.formErrors = []
      },
      onResize () {
        this.windowSize = { x: window.innerWidth, y: window.innerHeight }
        // console.log(this.windowSize)
      },
    },

  }
</script>

<style>
</style>
